import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'
import moment from 'moment'

import getByPath from 'lodash/get'

import { TextInput, TextEditor, TimePicker } from '../UI'
import PlacesAutocomplete from './PlacesAutocomplete'
import { NotificationManager } from 'react-notifications'

import { getPlaceInfoById } from './../../libs/utils'
import { defaultDate } from './index'

class Lodging extends Component {
  static propTypes = {
    onFormFieldChange: PropTypes.func.isRequired,
    onPlaceSelect: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    placeInputProps: PropTypes.object,
    dates: PropTypes.array,
    t: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      checkInDate: moment().startOf('day'),
      checkInTime: moment().startOf('day'),
      checkOutDate: moment().startOf('day'),
      checkOutTime: moment().startOf('day'),
      place: '',
      placeAddress: '',
      type: 'Lodging'
    }
  }

  onStartDateChange(checkInDate) {
    this.setState(
      {
        checkInDate: moment(checkInDate)
      },
      () => {
        this.checkStartDate(true)
      }
    )
  }

  checkStartDate(isDate) {
    if (isDate) {
      if (this.state.checkOutDate.isBefore(this.state.checkInDate)) {
        this.setState(
          {
            checkOutDate: this.state.checkInDate.clone().set({
              hours: this.state.checkOutTime.hours(),
              minutes: this.state.checkOutTime.minutes()
            })
          },
          () => {
            this.props.onFormFieldChange('endDate', this.state.checkOutDate.toISOString())
          }
        )
      }
    }

    const startDate = this.state.checkInDate.clone().set({
      hours: this.state.checkInTime.hours(),
      minutes: this.state.checkInTime.minutes()
    })

    this.props.onFormFieldChange('startDate', startDate.toISOString())
  }

  checkEndDate() {
    const endDate = this.state.checkOutDate.clone().set({
      hours: this.state.checkOutTime.hours(),
      minutes: this.state.checkOutTime.minutes()
    })

    this.props.onFormFieldChange('endDate', endDate.toISOString())
  }

  async onPlaceSelect(place, placeId) {
    let placeInfo

    this.props.onPlaceSelect(place, placeId)

    try {
      placeInfo = await getPlaceInfoById(placeId)
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }

    this.setState({
      placeAddress: placeInfo.formatted_address
    })
  }

  render() {
    const { onFormFieldChange, placeInputProps, dates, form, t } = this.props

    return (
      <div id="lodging-form" className="event__form--hidden">
        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('time')}</h2>

          <div className="mb-0 form-group">
            <label htmlFor="lodgingCheckIn" className="event__form-label col-md-3 control-label">
              {t('check_in_label')}
            </label>
            <div className="col-md-4">
              <select
                id="lodgingCheckIn"
                className="form-control event__form-input"
                value={this.state.checkInDate && this.state.checkInDate.toISOString()}
                onChange={e => {
                  this.onStartDateChange(e.target.value)
                }}
              >
                <option value="" disabled hidden>
                  {t('date_day_placeholder')}
                </option>
                {dates.map((day, i) => (
                  <option
                    key={i}
                    value={
                      day.dayOfTrip ||
                      defaultDate
                        .clone()
                        .add(i, 'days')
                        .toISOString()
                    }
                  >
                    {!!day.dayOfTrip && `${moment(day.dayOfTrip).format('MMM D')} / `}
                    {day.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-5">
              <TimePicker
                id="lodgingCheckInTime"
                value={this.state.checkInTime && this.state.checkInTime.toDate()}
                onChange={(id, checkInTime) => {
                  this.setState({ checkInTime }, () => {
                    this.checkStartDate()
                  })
                }}
                label={t('time')}
                labelClass="event__form-label col-md-3 control-label"
                extraClass="col-md-9"
              />
            </div>
          </div>
          <div className="mb-0 form-group">
            <label htmlFor="lodgingCheckOut" className="event__form-label col-md-3 control-label">
              {t('check_out_label')}
            </label>
            <div className="col-md-4">
              <select
                id="lodgingCheckOut"
                className="form-control event__form-input"
                value={this.state.checkOutDate && this.state.checkOutDate.toISOString()}
                onChange={e => {
                  this.setState(
                    {
                      checkOutDate: moment(e.target.value)
                    },
                    () => {
                      this.checkEndDate()
                    }
                  )
                }}
              >
                <option value="" disabled hidden>
                  {t('date_day_placeholder')}
                </option>
                {dates.map((day, i) => (
                  <option
                    key={i}
                    value={
                      day.dayOfTrip ||
                      defaultDate
                        .clone()
                        .add(i, 'days')
                        .toISOString()
                    }
                  >
                    {!!day.dayOfTrip && `${moment(day.dayOfTrip).format('MMM D')} / `}
                    {day.title}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-md-5">
              <TimePicker
                id="lodgingCheckInTime"
                value={this.state.checkOutTime && this.state.checkOutTime.toDate()}
                onChange={(id, checkOutTime) => {
                  this.setState({ checkOutTime }, () => {
                    this.checkEndDate()
                  })
                }}
                label={t('time')}
                labelClass="event__form-label col-md-3 control-label"
                extraClass="col-md-9"
                wrapperClass="mb-0"
              />
            </div>
          </div>
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('places')}</h2>
          <div className="form-group">
            <label htmlFor="lodgingPlaceAddress" className="event__form-label col-md-3 control-label">
              {t('place_label')}
            </label>
            <PlacesAutocomplete inputProps={placeInputProps} onSelect={(place, placeId) => this.onPlaceSelect(place, placeId)} />
          </div>

          {!!this.state.placeAddress && (
            <div className="form-group">
              <label htmlFor="activityPlaceAddress" className="event__form-label col-md-3 control-label" />
              <div className="col-md-9">
                <div className="formatted-address">{this.state.placeAddress}</div>
              </div>
            </div>
          )}

          <TextInput
            label={t('link__label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-9"
            wrapperClass="mb-0"
            isGroup={true}
            id="contentPOIs[0].website"
            extraClass="form-control event__form-input"
            placeholder={t('link__placeholder')}
            initialValue={getByPath(form, 'contentPOIs[0].website', '')}
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('description_label')}</h2>
          <div className="event__example-container">
            <i className="icon-flag event__example-icon" /> <span className="event__example-text">{t('description_example')}</span>
          </div>

          <TextEditor
              id="editor"
              value={form.description}
              placeholder={t('description_placeholder')}
              onChange={(content, delta, source, editor) => {
                onFormFieldChange('description', content)
              }}
          />
             
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('price')}</h2>
          <div className="form-group">
            <label htmlFor="activity-amount" className="event__form-label col-md-3 control-label">
              {t('amount_label')}
            </label>
            <div className="col-md-3">
              <input
                type="text"
                value={form.price}
                id="activity-amount"
                className="form-control event__form-input"
                placeholder={t('amount_placeholder')}
                onChange={e => (isNaN(+e.target.value) ? null : onFormFieldChange('price', +e.target.value))}
              />
            </div>
            <label htmlFor="lodgingCurrency" className="event__form-label col-md-2 control-label">
              {t('currency_label')}
            </label>
            <div className="col-md-3">
              <select
                id="currency"
                className="form-control event__form-input"
                value={form.currency}
                onChange={e => onFormFieldChange('currency', e.target.value)}
              >
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="NIS">NIS</option>
              </select>
            </div>
          </div>
          <TextInput
            label={t('book_through_label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-6"
            isGroup={true}
            id="eventDetails.bookedThrough"
            extraClass="form-control event__form-input"
            placeholder={t('book_through_placeholder')}
            initialValue={getByPath(form, 'eventDetails.bookedThrough', '')}
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />
          <TextInput
            label={t('confirmation_number_label')}
            labelClass="event__form-label col-md-3 control-label"
            inputWrapperClass="col-md-6"
            isGroup={true}
            id="eventDetails.confirmationCode"
            extraClass="form-control event__form-input"
            placeholder={t('confirmation_number_placeholder')}
            initialValue={getByPath(form, 'eventDetails.confirmationCode', '')}
            wrapperClass="mb-0"
            onChangeExternal={(id, value) => onFormFieldChange(id, value)}
          />
        </div>
      </div>
    )
  }
}

export default compose(
  translate('event', {
    withRef: true
  })
)(Lodging)



// WEBPACK FOOTER //
// src/components/Event/Lodging.js